import { testimonials } from '@/mocks/testimonials';

export default function TestimonialSection() {
  return (
    <section className="py-24 md:py-32 bg-background-100">
      <div className="w-full px-4 md:px-8 lg:px-16">
        <div className="max-w-7xl mx-auto">
          <div className="mb-14">
            <span className="inline-block px-4 py-1.5 rounded-full border border-primary-200 bg-primary-50 text-primary-700 text-xs font-medium mb-5">
              Cosa Dicono di Noi
            </span>
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 max-w-2xl">
              Persone reali,{' '}
              <span className="text-primary-500 italic">risultati reali</span>
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {testimonials.map((t, index) => (
              <div
                key={t.id}
                className={`p-6 rounded-2xl bg-background-50 border border-background-200 ${
                  index === 1 ? 'md:mt-8' : index === 4 ? 'md:mt-8' : ''
                } ${index === 3 ? 'md:-mt-8' : ''}`}
              >
                <div className="flex items-center gap-3 mb-4">
                  <div className={`w-10 h-10 rounded-full flex items-center justify-center text-sm font-bold ${t.avatarBg}`}>
                    {t.avatar}
                  </div>
                  <div>
                    <p className="text-sm font-semibold text-foreground-900">{t.name}</p>
                    <p className="text-xs text-foreground-400">{t.handle}</p>
                  </div>
                </div>
                <p className="text-sm text-foreground-600 leading-relaxed italic">
                  &ldquo;{t.text}&rdquo;
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}